import * as React from "react";
import { IPbrInputProps } from './PbrInput';
import InputMask from 'react-input-mask';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Input } from 'antd';
import "./PbrInput.scss";
import { PbrFormItem } from '../PbrFormItem/PbrFormItem';

export interface IPbrMaskedInputProps extends IPbrInputProps {
    mask: string;
    maskChar?: string;
    disabled?:boolean;
    formWrapper: WrappedFormUtils
}

export class PbrInputMask extends React.Component<IPbrMaskedInputProps> {


    public static defaultProps: Partial<IPbrMaskedInputProps> = {
        disabled: false
    };


    public render() {

        if (!this.props.mask) {
            return <PbrFormItem className="pbr-standard-input" {...this.props.formItemProps}>

                {this.props.formWrapper && this.props.formWrapper.getFieldDecorator<any>(this.props.name, {
                    rules: this.props.rules,
                    initialValue: this.props.value
                })(<Input disabled={this.props.disabled} type={this.props.type} />) || <Input disabled={this.props.disabled} type={this.props.type} />}
            </PbrFormItem>
        }

        return <PbrFormItem className="pbr-standard-input" {...this.props.formItemProps}>

            {this.props.formWrapper && this.props.formWrapper.getFieldDecorator<any>(this.props.name, {
                rules: this.props.rules,
                initialValue: this.props.value
            })(this.renderInput()) || this.renderInput()}
        </PbrFormItem>
    }
    
    private renderInput() {
        return <InputMask placeholder={this.props.placeholder} mask={this.props.mask} maskChar={this.props.maskChar} onChange={this.props.onChange}>
            {(inputProps) => <div><Input disabled={this.props.disabled} type={this.props.type}
                name={this.props.name}
                id={this.props.id}
                className={this.props.className}
                style={this.props.style}
                onKeyDown={this.props.onKeyDown}
                onInput={this.props.onInput}
                autoComplete={this.props.autoComplete}
                autoFocus={this.props.autoFocus} {...inputProps} /></div>}
        </InputMask>;
    }
}


// WEBPACK FOOTER //
// ./src/components/common/PbrInput/PbrInputMask.tsx